/*global google*/

import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ServerProperties from '../../config/server.js'
//import { toast } from 'react-toastify';

/* Google Maps Component */
const _ = require("lodash");
const { compose, withProps, lifecycle } = require("recompose");
const {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker
} = require("react-google-maps");
const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");
/* ---------------------- */

let currentLocationData = null;

const MapWithASearchBox = compose(
		withProps({
			onChange : (params) => getCurrentPosition(params)
	  	}),
		lifecycle({
			componentDidMount() {
		    	const refs = {}

			    this.setState({
			        bounds: null,
			        center: {
			          lat: this.props.defaultLocation.latitude,
			          lng: this.props.defaultLocation.longitude
			        },
			        markers: [],
			        onMapMounted: ref => {
			          refs.map = ref;
			          this.geocoder = new google.maps.Geocoder();
			        },
			        onIdle: () => {
			          this.setState({
			            bounds: refs.map.getBounds(),
			            center: refs.map.getCenter(),
			          })
			        },
			        onSearchBoxMounted: ref => {
			          refs.searchBox = ref;
			        },
			        onPlacesChanged: (e) => {
			          const places = refs.searchBox.getPlaces();
			          const bounds = new google.maps.LatLngBounds();

								if(places[0] !== undefined) {
									try {
										this.props.onChange({
											latLng : {
												lat : places[0].geometry.location.lat(),
												lng : places[0].geometry.location.lng()
											},
											geo : this.geocoder
										});	

										places.forEach(place => {
											if (place.geometry.viewport) {
												bounds.union(place.geometry.viewport)
											} else {
												bounds.extend(place.geometry.location)
											}
										});

										const nextMarkers = places.map(place => ({
											position: place.geometry.location,
										}));
		
										const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
		
										this.setState({
											center 	: nextCenter,
											markers : nextMarkers,
										});

									} catch (error) {
										alert("Daily quota requests for API maps have exceeded the limit. so maps cannot be used temporary. Please info administrator to change API map.")
									}
								}
			        },

			        onMarkerChanged: (e) => {
			        	// console.log(e)
			        	this.props.onChange({
			        		latLng 	: {
			        			lat : e.latLng.lat(),
			        			lng : e.latLng.lng()
			        		},
			        		geo 	: this.geocoder
			        	});
			        },
			    })
		    },
		}),
		withScriptjs,
		withGoogleMap)(props =>
		<div>
			<GoogleMap
				defaultZoom 	= {12}
				center 			= {props.center}
				ref 			= {props.onMapMounted}
				onBoundsChanged = {props.onBoundsChanged}
				onDblClick 		= {props.onMarkerChanged}
				defaultOptions 	= {{
			    	fullscreenControl 			: true,
			    	fullscreenControlOptions 	: {
				    	position : google.maps.ControlPosition.RIGHT_TOP
				    },
				    mapTypeControl 			: true,
				    mapTypeControlOptions 	: {
				    	position : google.maps.ControlPosition.TOP_RIGHT
				    }
			    }}
			>
			    <SearchBox
			      ref 				= {props.onSearchBoxMounted}
			      bounds 			= {props.bounds}
			      controlPosition 	= {google.maps.ControlPosition.TOP_LEFT}
			      onPlacesChanged 	= {props.onPlacesChanged}
			    >
			      <input
			        type 		= "text"
			        placeholder = "Search Place..."
			        style 		= {inputTextStyle}
			      />
		   		</SearchBox>
			    {props.markers.map((marker, index) =>
			    	<Marker
			    		key 		= {index}
			    		position 	= {marker.position}
			    		onDragEnd 	= {props.onMarkerChanged}
			    		draggable 	= {true}
			    	/>
			    )}
			</GoogleMap>
		</div>
);

const geocodeLatLng = (geocoder, latLng, callback) => {
    geocoder.geocode({'location': latLng}, (results, status) => {
    	// console.log(results)
        if (status === 'OK') {
            if (results) {
            	callback(results)
            } else {
            	callback(null);
            }
        } else {
            callback(null);
        }
    });
};

const geoResult = (result) => {
	const gmapSearchURL = 'https://www.google.com/maps/'
	const p1 			= 'locality'
	const p2 			= 'political'
	if (result === null || result.length <= 0){
		currentLocationData.address = 'Unknown Address'
		currentLocationData.mapURL 	= gmapSearchURL
										+ 'search/?api=1&query='
										+ currentLocationData.latitude
										+ ',' + currentLocationData.longitude
	}else{
		// Get address
		currentLocationData.address = result[0].formatted_address;

		// Get address 2
		if (result.length > 1){
			currentLocationData.address2 = result[result.length - 2].formatted_address
		}else{
			try{
				currentLocationData.address2 = result[0]
					.address_components[result[0]
					.address_components.length - 2]
					.long_name
			}catch(err){
				currentLocationData.address2 = ''
			}
		}

		// get mapURL
		currentLocationData.mapURL 	= gmapSearchURL
										+ 'search/?api=1&query='
										+ encodeURI(result[0].formatted_address)

		// get postal
    	result[0].address_components.forEach(res => {
    		if(res.types.includes('postal_code')){
    			currentLocationData.postal = res.long_name
    		}
    	});

    	// get city
    	result.forEach(res => {
	    	if(res.types.includes(p1) && res.types.includes(p2)){
	    		res.address_components.forEach(val => {
	    			if(val.types.includes(p1) && val.types.includes(p2)){
	    				currentLocationData.city = val.long_name.toLowerCase()
	    			}
	    		})
	    	}
    	});
	}

	// Get streetviewURL
	currentLocationData.streetViewURL 	= gmapSearchURL
											+ '@?api=1&map_action=pano&viewpoint='
											+ currentLocationData.latitude
											+ ',' + currentLocationData.longitude
											+ '&heading=-45&pitch=38&fov=80'
};

const getCurrentPosition = (params) => {
	currentLocationData.latitude 	= params.latLng.lat;
	currentLocationData.longitude 	= params.latLng.lng;
	geocodeLatLng(params.geo, params.latLng, geoResult);
};

const inputTextStyle = {
	boxSizing: 'border-box',
	border: '1px solid transparent',
	width: '400px',
	height: '32px',
	marginTop: '10px',
	marginLeft: '10px',
	padding: '0 12px',
	borderRadius: '3px',
	boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
	fontSize: '14px',
	outline: 'none',
	textOverflow: 'ellipses',
	left: '10px'
};

export default class ModalSelectInMap extends React.Component {
	onSave(){
		this.props.onSave(currentLocationData);
		this.props.closeModal();
	};

	willMount(){
		currentLocationData = {
			latitude: '',
			longitude: '',
			address: '',
			address2: '',
			city: '',
			postal: '',
			mapURL: '',
			streetViewURL: ''
		}
		try{
			this.props.onOpen();
		}catch(err){}
	};

	willUnMount(){
		try{
			this.props.onClose();
		}catch(err){}
	};

	render(){
		return(
			<Modal
				isOpen		= {this.props.isOpen} /*onEnter={willMount()}*/
				onExit		= {() => this.willUnMount()}
				onEnter 	= {() => this.willMount()}
				toggle 		= {this.props.closeModal}
				backdrop  = "static"
				className 	= "modal-map"
			>
				<ModalHeader toggle={this.props.closeModal}>Select In Maps</ModalHeader>
				<ModalBody>
					<MapWithASearchBox
						googleMapURL 		= {ServerProperties.GOOGLE_MAP.API + '&libraries=geometry,drawing,places'}
						loadingElement 		= {<div style={{ height: 100 }} />}
						containerElement 	= {<div style={{ height: '78vh', width: '100%'}} />}
						mapElement 			= {<div style={{ height: '100%', width:'100%'}} />}
						defaultLocation 	= {this.props.defaultLocation}
					/>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={this.props.closeModal}>Cancel</Button>
					<Button
						color="primary"
						onClick={() => this.onSave()}
					>
						Save
					</Button>{' '}
				</ModalFooter>
			</Modal>
		)
	};
};



// WEBPACK FOOTER //
// ./src/App/utils/Modal/ModalSelectInMap.js